import { map, values, pathOr, has } from 'ramda';
import { GET_BARBERS } from '../../main/barbers/constants';
import { RESET_FILTERS } from '../../main/reports/constants';

const transform = item => ({
  ...item,
  checked: has('active', item) ? item.active : true,
  type: 'barber',
});
const transformToFilter = map(transform);

const barberFilter = ({ add, remove, show, hide, set = GET_BARBERS, includeUnassigned = false }) => (state = [], action) => {
  switch (action.type) {
    case add:
      return state.map((filter) => {
        if (filter.id === action.barber) {
          filter.checked = true;
        }
        return filter;
      });
    case remove:
      return state.map((filter) => {
        if (filter.id === action.barber) {
          filter.checked = false;
        }
        return filter;
      });
    case show:
    case RESET_FILTERS:
      return state.map((filter) => {
        filter.checked = true;
        return filter;
      });
    case hide:
      return state.map((filter) => {
        filter.checked = false;
        return filter;
      });
    case set: {
      const barbers = action.payload || values(pathOr([], ['response', 'entities', 'barbers'], action));
      if (!includeUnassigned) {
        return transformToFilter(barbers);
      }

      return [
        transform({
          id: 'unassigned',
          firstName: 'Unassigned',
        }),
        ...transformToFilter(barbers),
      ];
    }
    default:
      return state;
  }
};

export default barberFilter;
